import { useTranslation } from 'react-i18next';
import { VGSFormErrorMessages } from '../constants/vgsForm';

const useVgsFormErrorMessage = (translationKey?: string, fieldLabel?: string): string | undefined => {
  const { t } = useTranslation('ERRORS');

  if (!translationKey) {
    return undefined;
  }

  const translationBase = t(translationKey);
  return translationKey === VGSFormErrorMessages.IS_REQUIRED
    ? `${fieldLabel ?? ''} ${translationBase}`
    : translationBase;
};

export default useVgsFormErrorMessage;
